module.exports = __webpack_public_path__ + "img/leaf.f75e5dfe.svg";